<script type="text/javascript">
	import moment from "moment";

	import MenuItem from "../FlyoutMenu/MenuItem.svelte";
	import Icon from "../Icons/Icon";

	import MySvelteTable from "../AlertList/MySvelteTable.svelte";
	import Datepicker from "svelte-calendar";
	import Radio from '@smui/radio';
	import FormField from '@smui/form-field';
	import Textfield, {Input, Textarea} from "@smui/textfield";
	import IMOCounter from '../IMOCounter.svelte';
	import HelperText from "@smui/textfield/helper-text/index";
	import DataTable, {Head, Body, Row, Cell} from '@smui/data-table';
	import Button, {Label} from '@smui/button';
	import Card from '@smui/card';

	import LayerListSwitch from '../LayerList/LayerListSwitch.svelte';

	import { onMount, onDestroy } from "svelte";
	import { get, writable } from "svelte/store";

	import MapStore from "../../Map/Store";
	import InfoCardStore from "../InfoCard/Store";
	import VesselsNearbyStore from "./Store";
	import Vessel from "../../Models/Vessel";
	import VesselIDType from "../../Models/Enums/VesselIDType";
	import VesselProperty from "../../Models/Enums/VesselProperty";
	import VesselSpireDataPropertyMap from "../../Models/Enums/VesselSpireDataPropertyMap";
	import AlertType from "../../Alerts/AlertType";

	import User from "../../Branding/User";
	import Feature from "../../Branding/Feature";

	import GeoHelper from "../../Helpers/GeoHelper";
	import StringHelper from "../../Helpers/StringHelper";
	import FilterHelper from "../../Helpers/FilterHelper";
	import checkImoIsValid from "../../Helpers/Misc/imoValidator";
	import roundFloat from "../../Helpers/Misc/roundFloat";

	import LoadState from "../../Enums/LoadState";

	import MapLayer from "../../Map/Enums/MapLayer";
	import MapViewType from "../../Map/Enums/MapViewType";
	import MapLayerManager from "../../Map/MapLayerManager";

	import API from "../../API/API";
	import Router from "../../Router";

	import "./VesselsNearby.scss";

	import TextfieldWithButton from "../../UI/TextfieldWithButton/TextfieldWithButton.svelte";

	import LoadingStore from "../../LoadingStore";
	
	import FiltersComponent from "../../Filters/FiltersComponent.svelte";
	import FiltersButtonMenu from "../../Filters/FiltersButtonMenu.svelte";
	import "../../UI/AlertFilters/AlertFilters.scss";
	import KeyComponent from "../Key/KeyComponent.svelte";
	import AlertsStore from "../../Alerts/Store";
	import Analytics from "../../Analytics/Analytics";
	import AuthStore from "../../Auth/Store";
import VesselKeyComponent from "../Key/VesselKeyComponent.svelte";

	let state = VesselsNearbyStore.meta.loadState;
	let error = VesselsNearbyStore.meta.error;
	let lastUpdated = VesselsNearbyStore.meta.lastUpdated;

	let resultsTableRowsFiltered = VesselsNearbyStore.results.tableData.filtered;

	let resultsMetaTotal = VesselsNearbyStore.results.meta.total;
	let resultsMetaLimit = VesselsNearbyStore.results.meta.limit;
	let vessels = VesselsNearbyStore.results.vesselGroup.vessels;
	let vesselSpireIdsSelected = VesselsNearbyStore.results.vesselGroup.selected[VesselProperty.SPIRE_ID];
	
	let rawVesselSelectedChanged = (selected) => {
		console.log("rawVesselSelectedChanged", $vessel)
		if ($vessel) {
			let uniqueIdType = VesselProperty.SPIRE_ID;
			$vessel.addOrRemovePropertyToWritableList(uniqueIdType, vesselSpireIdsSelected, selected);
		}	
	};

	let onSubmit = () => {
		$state = LoadState.LOADING;
		$lastUpdated = Date.now();

		
		// let from = get(VesselsNearbyStore.query.computed.fromDatetime).toISOString();
		// let to = get(VesselsNearbyStore.query.computed.toDatetime).toISOString();
		// let from = new Date(Date.now() - 86400000).toISOString();
		let from = moment(Date.now()).subtract($timeWindowHrs, "hours").toDate().toISOString();
		let to = new Date(Date.now()).toISOString();
		let polygonObj = get(VesselsNearbyStore.query.computed.polygon);
		let polygon = JSON.stringify(polygonObj.geometry);
		
		Analytics.event("query", { 
			category: "Nearby Vessels", 
			username: get(AuthStore.userInfo).username, 
			from: from, 
			to: to,  
			lngLat: get(VesselsNearbyStore.query.raw.lngLat)
		});

		let url = "vessels/nearby?polygon=" + encodeURIComponent(polygon) + "&timestamp_after=" + from + "&timestamp_before=" + to;
		let flags = [];
		let vesselTypes = [];
		if (preFilters && preFilters.sets.length === 1) {
			let clauses = preFilters.sets[0].clauses;
			for (let i = 0; i < clauses.length; i++) {
				let condition = preFilters.sets[0].clauses[i];
				if (condition.property.length > 0) { 
					console.log(condition.property, condition.value);
				}
				if (condition.property === "flag") {
					flags.push( condition.value );
				}
				else if (condition.property === "vesselType") {
					vesselTypes.push( condition.value );
				}
			}
		}
		if (flags.length > 0) {
			url += "&flag=" + flags.join(",");
		}
		if (vesselTypes.length > 0) {
			url += "&ship_type=" + vesselTypes.join(",");
		}
		API.get(url)
			.then((results)=>{
				console.log(results);

				$resultsMetaTotal = results.paging.total;
				$resultsMetaLimit = results.paging.limit;

				let vesselResults = [];
				results.data.forEach((feature)=>{

					let newVessel;
					if ($vessel &&
						feature.properties.name === $vessel.name &&
						feature.properties.imo === $vessel.imo
						) {
						newVessel = $vessel;
						newVessel.addOrRemovePropertyToWritableList(VesselProperty.SPIRE_ID, vesselSpireIdsSelected, $vessel.selected);
					}
					else {
						feature.properties[VesselSpireDataPropertyMap[VesselProperty.SPIRE_ID]] = feature.properties.id;

						newVessel = new Vessel(feature, AlertType.NONE, AlertType.DEFAULT_CATEGORY_NAME, VesselsNearbyStore.results.vesselGroup, VesselSpireDataPropertyMap);
						newVessel.setUniqIdType(VesselProperty.SPIRE_ID);
					}
					vesselResults.push(newVessel);
				});

				VesselsNearbyStore.results.vesselGroup.vessels.set(vesselResults);
				//VesselsNearbyStore.results.vessels.filtered.set(vessels);

				MapStore.helpers.zoomToFeaturesArray(results.data);

				$state = LoadState.LOADED;
				$error = "";
			})
			.catch((err)=>{
				console.error(err);

				$state = LoadState.INIT;
				$error = error;
			})
	};
	onMount(()=>{

		if ($vessel) {
			$vessel.onSelectedChanged.add(rawVesselSelectedChanged);
			$vessel.selected = $vessel.selected;
		}
	});
	onDestroy(() => {
		if ($vessel) {
			$vessel.selected = $vessel.selected; 
			$vessel.onSelectedChanged.remove(rawVesselSelectedChanged);
		}
	});

	let onReset = () => {
		Analytics.event("reset_form", { category: "Nearby Vessels", username: get(AuthStore.userInfo).username });
		VesselsNearbyStore.actions.resetAll();
	}
	let updateTable = () => {
		const filteredVessels = VesselsNearbyStore.results.getFilteredVessels();		
		filteredVessels.forEach(vessel => vessel.setIconMode($iconMode));
		$resultsTableRowsFiltered = filteredVessels.map((vessel) => {
			return {
				imo: (vessel.imo)?vessel.imo:"Unknown",
				imoValue: vessel.imo,
				name: vessel.name,
				mmsi: vessel.mmsi,
				spireId: vessel.spireId,
				selected: vessel.selected
			};
		});
		VesselsNearbyStore.actions.compute();
	};

	$: {
		// When vessels results changes, update the table and map.
		$vessels;
		updateTable();
	}

	let vessel = VesselsNearbyStore.query.raw.useVessel;

	let timeWindowHrs = VesselsNearbyStore.query.raw.timeWindowHrs;
	let timeWindowOptions = [1,2,4,8,12,24];

	let baseDatetime = VesselsNearbyStore.query.raw.baseDatetime;
	let baseDateTimeReadable;
	$: {
		baseDateTimeReadable = moment($baseDatetime).format("YYYY/MM/DD HH:mm a");
	}

	let lngLat = VesselsNearbyStore.query.raw.lngLat;
	let lngLatReadable = "";
	$: {
		if ($vessel !== null) {
			lngLatReadable = roundFloat($lngLat.lng, 2) + ", " + roundFloat($lngLat.lat, 2);
		}
	}

	let radius = VesselsNearbyStore.query.raw.radiusNm;

	let updateDateTime = (e) => {
		const value = e.target.value;
		const momentValue = moment(value, "YYYY/MM/DD HH:mm a");
		//console.log("updateDateTime", value, momentValue);
		VesselsNearbyStore.query.raw.baseDatetime.set(momentValue);
	};
	let updatePoint = (e = null) => {
		if (e) {
			lngLatReadable = e.target.value;
		}
		const parsedLngLat = GeoHelper.parseStringLngLat(lngLatReadable);
		//console.log("updatePoint", lngLatReadable, parsedLngLat, e);
		$lngLat.lng = parsedLngLat[0];
		$lngLat.lat = parsedLngLat[1];
		VesselsNearbyStore.actions.compute();
	};
	let updatePolygon = () => {
		//console.log("updatePolygon");
		VesselsNearbyStore.actions.compute();
	};

	onMount(() => {
		VesselsNearbyStore.actions.initMap( MapStore.helpers.getMap() );

		LoadingStore.add("vessels_nearby", VesselsNearbyStore.meta.loadState);

		VesselsNearbyStore.results.vesselGroup.uniqidType = VesselProperty.SPIRE_ID;

		InfoCardStore.actions.close();
		MapStore.actions.setViewType(MapViewType.NEARBY_VESSELS);
		MapLayerManager.updateVisibleLayers();
		VesselsNearbyStore.actions.compute();

		return () => {
			// ...?
			LoadingStore.remove("vessels_nearby");
			VesselsNearbyStore.actions.deinitMap();
		};
	});

	let resultsTableColumns = [
		{
			key: "imo",
			title: "IMO",
			value: v => v.imo,
			sortable: true,
			renderValue: (v, v2) => {
				return v.imo;
			},
			class: v => {
				return v.selected ? "selected" : "";
			},
			headerClass: "imo"
		},
		{
			key: "mmsi",
			title: "MMSI",
			value: v => v.mmsi,
			sortable: true,
			class: v => {
				return v.selected ? "selected" : "";
			},
			headerClass: "mmsi"
		},
		{
			key: "name",
			title: "Name",
			value: v => v.name,
			renderValue: v => "<span title='" + v.name + "'>" + v.name + "</span>",
			sortable: true,
			class: v => {
				return "name " + (v.selected ? "selected" : "");
			},
			headerClass: "name"
		}
	];


	let gotoVesselHistory = () => {
		const useAll = VesselsNearbyStore.results.vesselGroup.countSelected() === 0;
		let mmsis = $resultsTableRowsFiltered

		if (User.hasFeature(Feature.VESSEL_HISTORY.SEARCH_BY_MMSI)) {
			let mmsis = $resultsTableRowsFiltered
					.filter((row) => { return row.selected || useAll; })
					.map((row)=>{ return row.mmsi })
					.filter((mmsi) => { return mmsi != null });

			Router.actions.gotoVesselHistoryForList(VesselIDType.MMSI, mmsis);
		}
		else {
			let imos = $resultsTableRowsFiltered
					.filter((row) => { return row.selected || useAll; })
					.map((row)=>{ return row.imoValue })
					.filter((imo) => { return imo != null });

			Router.actions.gotoVesselHistoryForList(VesselIDType.IMO, imos);
		}
	};
	let onCellClick = (event) => {
		const imo = event.detail.row.imo;
		const spireId = event.detail.row.spireId;

		const vessel = VesselsNearbyStore.results.vesselGroup.find({[VesselProperty.SPIRE_ID]: spireId});
		if (vessel) {
			vessel.selected = !vessel.selected;
		}
		// else {
		// 	console.warn("vessel not found,", spireId, imo);
		// }

		updateTable();
	};
	let clearSelected = () => {
		//VesselsNearbyStore.actions.deselectAllVessels();
		VesselsNearbyStore.results.vesselGroup.deselectAll();
		if ($vessel) {
			$vessel.selected = false;
		}
		updateTable();
	};

	VesselsNearbyStore.results.vesselGroup.vessels.subscribe(() => {
		updateTable();
	});

	MapStore.meta.initialised.subscribe((initialised) => {
		if (initialised) {
			const map = MapStore.helpers.getMap();
			map.on("click", MapLayer.VESSELS_NEARBY, event => {
				event.preventDefault();

				const group = VesselsNearbyStore.results.vesselGroup;
				group.selectSingle(map, event, [MapLayer.VESSELS_NEARBY], [VesselProperty.SPIRE_ID]);
			});
		}
	});

	//
	// FILTERS
	//
	let filters = VesselsNearbyStore.filters.advanced;
	let filtersLastUpdated = VesselsNearbyStore.filters.lastUpdated;
	let advancedFiltersUpdated = filters.lastUpdated;

	let iconMode = AlertsStore.iconMode; // TODO: Global icon mode outside of AlertsStore?
	$: {
		$filtersLastUpdated = $advancedFiltersUpdated;
		filters = filters;
		
		$iconMode;

		VesselsNearbyStore.filters.lastUpdated.set(new Date());
		// AlertsStore.actions.updateMapSources();
		updateTable();
	}

	let preFilters = VesselsNearbyStore.preFilters.advanced;
	let preFiltersLastUpdated = VesselsNearbyStore.preFilters.lastUpdated;
	let preAdvancedFiltersUpdated = preFilters.lastUpdated;
	$: {
		$preFiltersLastUpdated = $preAdvancedFiltersUpdated;
		preFilters.multisetEnabled = false;
		preFilters = preFilters;
		VesselsNearbyStore.preFilters.lastUpdated.set(new Date());
	}


	let vesselTypeOptions = [];
	let flagOptions = [];
	let destinationOptions = [];
	$: {
		$lastUpdated;

		// We need to build the enum options for the filters. Use the global dataset for this.
		vesselTypeOptions = $vessels.map((vessel) => { return vessel.classification; }).filter(FilterHelper.unique).sort();
		flagOptions = $vessels.map((vessel) => { return vessel.flag; }).filter(FilterHelper.unique).sort();
		destinationOptions = $vessels.map((vessel) => { return vessel.voyageDestination; }).filter(FilterHelper.unique).sort();

		filters.setPropertyEnumOptions("classification", vesselTypeOptions);
		filters.setPropertyEnumOptions("flag", flagOptions);
		filters.setPropertyEnumOptions("voyageDestination", destinationOptions);
	}


</script>

<div class='vessels-nearby-components'>

	<MenuItem title={"Query Nearby Vessels"} materialIcon={"query_builder"}>

		<div slot="context-menu">
			<FiltersButtonMenu filters={preFilters} hackStyle={"left:-122px;"}/>
		</div>


		{#if $vessel !== null}
			<h2>Vessel:</h2>
			<p>{$vessel.name} ({$vessel.imo})</p>

			<!-- <h2>Date/time</h2>
			<p>{$vessel.snapshotTimestamp}</p> -->

			<h2>Date/time:</h2>
			<p>Now</p>

			 <h2>Time Window:</h2>
			<select class='default' bind:value={$timeWindowHrs} style="width:100%;" disabled={$state === LoadState.LOADING}>
				<option value={0} selected={$timeWindowHrs === 0}>Please select</option>
				{#each timeWindowOptions as option}
					<option value={option} selected={$timeWindowHrs === option}>- {option} hrs</option>
				{/each}
			</select><br/>

			<h2>Point (lng, lat):</h2>
			<p>{$vessel.coordinates}</p>
		{:else}

			<!-- <h2>Date/time:</h2>
			<Textfield dense variant="filled" value={baseDateTimeReadable} on:keyup={updateDateTime} disabled={$state === LoadState.LOADING} /><br/> -->

			<h2>Date/time:</h2>
			<p>Now</p>

			<h2>Time Window:</h2>
			<select class='default' bind:value={$timeWindowHrs} style="width:100%;" disabled={$state === LoadState.LOADING}>
				<option value={0} selected={$timeWindowHrs === 0}>Please select</option>
				{#each timeWindowOptions as option}
					<option value={option} selected={$timeWindowHrs === option}>-{option} hrs</option>
				{/each}
			</select><br/>

			<h2>Point (lng, lat):</h2>
			<TextfieldWithButton
				value={lngLatReadable}
				disabled={$state === LoadState.LOADING}
				buttonIcon="colorize"
				on:keyup={(e) => {
					updatePoint(e);
					updatePolygon();
				}}
				on:buttonclick={(e) => {
					MapStore.helpers.startSingleLngLatPick((resultText)=>{
						lngLatReadable = resultText;
						updatePoint();
						updatePolygon();
					});
				}}
				/>
		{/if}

		<h2>Radius (nm):</h2>
		<Textfield dense variant="filled" bind:value={$radius} on:keyup={updatePolygon} disabled={$state === LoadState.LOADING} /><br/>

		<h2>Filters:</h2>
		<div class="filters-component">
			<div class="content">
				<FiltersComponent name="vessels-nearby-prefilter" filters={preFilters} />
			</div>
		</div>

		<Button on:click={onSubmit} color="secondary" variant="unelevated" id="vessels-nearby-submit" style="width:100%;margin-top:10px;" disabled={$state === LoadState.LOADING}><Label>Submit</Label></Button>
		<Button on:click={onReset} title="Reset" class='bg-info' variant="unelevated" style="width:100%;margin-top:5px;" disabled={$state === LoadState.LOADING}><Label>Reset</Label></Button>
	</MenuItem>

	{#if $state === LoadState.LOADED}
		<MenuItem title={"Results"} materialIcon={"directions_boat"} class="filters-component">
			<div slot="context-menu">
				{#if User.hasFeature(Feature.ALERTS.FILTER)}
					<FiltersButtonMenu filters={filters} hackStyle={"left:-152px;"}/>
				{/if}
			</div>

			<div class="content">
				<FiltersComponent name="vessels-nearby" filters={filters} />
			</div>

			{#if $resultsMetaTotal > $resultsMetaLimit}
				<div class='warning bg-warning'>
					Returned {$resultsMetaTotal} results but only showing {$resultsMetaLimit}. Please narrow your search criteria.
				</div>
			{/if}

			<div class="selection-list-element">
				<div class="alert-list-content mdc-elevation--z2" style="height:auto;">
					<MySvelteTable
						on:clickCell={onCellClick}
						rows={$resultsTableRowsFiltered}
						columns={resultsTableColumns} />
				</div>
				<Button title="Clear Selection" class='bg-error' color="secondary" variant="unelevated" style="width:100%;" on:click={clearSelected}><Label>Clear Selected</Label></Button>

				<Button class='bg-primary' color="secondary" variant="unelevated" style="width:100%;" on:click={gotoVesselHistory}>
					<Label>
						Check Vessel History
						{#if $vesselSpireIdsSelected.length > 0}
							({$vesselSpireIdsSelected.length} selected)
						{/if}
					</Label>
				</Button>
			</div>



		</MenuItem>

		<VesselKeyComponent defaultModeName="Default" disabled={$state === LoadState.LOADING}/>
	{/if}

</div>
